export const ExtraRealTreeIcon = () => (
  <svg
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_599_17655)">
      <path
        d="M22.9996 41.6501C12.7096 41.6501 4.34961 33.2801 4.34961 23.0001C4.34961 12.7201 12.7096 4.3501 22.9996 4.3501C33.2896 4.3501 41.6496 12.7201 41.6496 23.0001C41.6496 33.2801 33.2796 41.6501 22.9996 41.6501Z"
        fill="url(#paint0_linear_599_17655)"
      />
      <path
        d="M23.0009 37.6199C31.0809 37.6199 37.6209 31.0699 37.6209 22.9999C37.6209 14.9299 31.0709 8.37988 23.0009 8.37988C14.9309 8.37988 8.38086 14.9299 8.38086 22.9999C8.38086 31.0699 14.9309 37.6199 23.0009 37.6199Z"
        fill="url(#paint1_linear_599_17655)"
      />
      <path
        opacity={0.62}
        d="M23.0207 28.9914C22.3629 28.9914 21.73 28.8025 21.1721 28.4504C18.4906 26.733 17.0167 24.5519 17 22.3021C17 21.1514 17.458 20.0351 18.2741 19.2365C19.0652 18.4637 20.1061 18.0343 21.2054 18.0258C21.8299 18.0258 22.4378 18.1546 22.9874 18.4036C23.537 18.146 24.1283 18 24.7279 18C27.0845 18 28.9832 19.8977 28.9999 22.2248C29.0165 24.4575 27.5675 26.6557 24.9277 28.4161C24.3615 28.7939 23.7036 29 23.0207 29V28.9914Z"
        fill="url(#paint2_linear_599_17655)"
      />
      <path
        d="M20.8698 20.1101C21.6298 20.1101 22.3198 20.4901 22.6998 20.9901C22.8098 21.1301 22.9998 21.4201 22.9998 21.4201C22.9998 21.4201 23.2198 21.1201 23.3298 20.9901C23.7198 20.4801 24.3998 20.0901 25.1098 20.0801C26.2798 20.0801 27.2398 20.9501 27.2498 22.0501C27.2598 24.2001 24.8998 25.9901 23.7098 26.7601C23.2998 27.0201 22.7798 27.0301 22.3598 26.7701C21.1598 26.0201 18.7698 24.2601 18.7598 22.1101C18.7598 21.0101 19.6898 20.1101 20.8698 20.1001V20.1101Z"
        fill="white"
      />
      <path
        d="M15.3606 12.97C15.3606 14.73 13.9406 16.15 12.1906 16.15C11.5206 16.15 10.9006 15.94 10.3906 15.59C11.4706 13.76 12.9306 12.2 14.6606 11C15.0906 11.54 15.3506 12.22 15.3506 12.97H15.3606Z"
        fill="url(#paint3_linear_599_17655)"
      />
      <path
        d="M26.0191 37.31C25.0491 37.52 24.0291 37.63 22.9991 37.63C16.9491 37.63 11.7791 33.97 9.53906 28.75H14.1391C16.0091 28.75 17.5991 30.02 18.0591 31.74H20.1291C23.2791 31.74 25.8491 34.21 25.9991 37.32L26.0191 37.31Z"
        fill="url(#paint4_linear_599_17655)"
      />
      <path
        d="M37.4707 20.9199C34.0407 20.6599 31.2607 18.0499 30.7807 14.6899H28.1407C25.6907 14.6899 23.7207 12.7199 23.7207 10.2899C23.7207 9.61993 23.8707 8.98993 24.1407 8.42993C31.0007 8.94993 36.5107 14.1999 37.4707 20.9199Z"
        fill="url(#paint5_linear_599_17655)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_599_17655"
        x1={19.0196}
        y1={51.6601}
        x2={26.0796}
        y2={0.800099}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E700" />
        <stop offset={0.52} stopColor="#00FF00" stopOpacity={0.89} />
        <stop offset={0.62} stopColor="#19FF00" stopOpacity={0.91} />
        <stop offset={0.82} stopColor="#59FF00" stopOpacity={0.95} />
        <stop offset={1} stopColor="#99FF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_599_17655"
        x1={23}
        y1={42}
        x2={23}
        y2={8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#008A7C" />
        <stop offset={1} stopColor="#00DF00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_599_17655"
        x1={21.5968}
        y1={14.7884}
        x2={24.839}
        y2={31.0495}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1FD00" stopOpacity={0.8} />
        <stop offset={1} stopColor="#00FF6C" stopOpacity={0.3} />
      </linearGradient>
      <linearGradient
        id="paint3_linear_599_17655"
        x1={17.3506}
        y1={17.47}
        x2={11.7606}
        y2={12.61}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#04541A" />
        <stop offset={1} stopColor="#027E14" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_599_17655"
        x1={20.5233}
        y1={40.2525}
        x2={12.5}
        y2={25.5}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.03} stopColor="#04541A" />
        <stop offset={1} stopColor="#027A15" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_599_17655"
        x1={43.2807}
        y1={26.4299}
        x2={22.0607}
        y2={6.25993}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.03} stopColor="#04531A" />
        <stop offset={1} stopColor="#027D15" />
      </linearGradient>
      <clipPath id="clip0_599_17655">
        <rect width={46} height={46} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
